import DataStore from "@shared/services/DataStore";
import {I18n} from "../LangUtil";
const OMN = {
  getIdOpts(){
    return {
      label: I18n('g.lbl.civilid'),
      sizeRange: [4,12]
    }
  },
  getMessages(){
    return {
      blackListedMsg: I18n('g.msg.blacklistedcustomn'),
      additionalRemittanceThxText: I18n('g.lbl.addthx')
    }
  },
  getTenantInfo(){
    return {
      name: "Modern Exchange"
    }
  },
  getSupportInfo(){
    return {
      custPhone: DataStore.getData().customerCareDetails.custPhone,
      custEmail: DataStore.getData().customerCareDetails.custEmail,
      time: DataStore.getData().customerCareDetails.time
    }
  },
  getMobilePrefix(){
    return "+968"
  },
  getThankyouText(){
    return "Thank you for choosing Modern Exchange";
  }
};

export default OMN;
